import { render, staticRenderFns } from "./HeaderUserWidget.vue?vue&type=template&id=115b4884&scoped=true&"
import script from "./HeaderUserWidget.vue?vue&type=script&lang=ts&"
export * from "./HeaderUserWidget.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderUserWidget.vue?vue&type=style&index=0&id=115b4884&lang=scss&scoped=true&"
import style1 from "./HeaderUserWidget.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115b4884",
  null
  
)

export default component.exports